import { useSafeAreaInsets } from 'react-native-safe-area-context';
import {
    ThumbsDownIcon,
    ThumbsUpIcon,
    TileButton,
    View,
    XStack,
} from 'smoothie';

interface BillDetailsNewBillButtonsProps {
    onApprove: () => void;
    onReject: () => void;
}

const BillDetailsNewBillButtons = ({
    onApprove,
    onReject,
}: BillDetailsNewBillButtonsProps) => {
    const { bottom } = useSafeAreaInsets();

    return (
        <View paddingBottom={bottom}>
            <XStack gap={12} height={66}>
                <TileButton
                    tileProps={{ backgroundColor: '$green200' }}
                    onPress={onApprove}
                    icon={ThumbsUpIcon}
                    color="$green1100"
                    text="Looks correct"
                />
                <TileButton
                    tileProps={{ backgroundColor: '$red200' }}
                    onPress={onReject}
                    icon={ThumbsDownIcon}
                    color="$red1100"
                    text="Looks wrong"
                />
            </XStack>
        </View>
    );
};

export default BillDetailsNewBillButtons;
